// import React, { useState, useRef } from "react";
// import { useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";
// import "./MemberPrint.css";

// import {
//   DetailTable,
//   PhotoTable,
//   NomineePhotoTable,
//   memberFields,
//   businessFields,
//   residenceFields,
//   permanentResidenceFields,
//   CoApplicantPersonalFields,
//   coApplicantBusinessFields,
//   coApplicantResidenceFields,
//   coApplicantPermanentResidenceFields,
//   loanDetailsFields,
//   proposedLoanDetailsFields,
//   bankDetailsFields,
// } from "../../../components/ui/TablePrintFormat";

// import MemberSanctionLetter from "../../loans/components/MemberSanctionLetter";
// import DisbursementRequestForm from "../../users-management/components/DisbursementRequestForm";
// import GeneratedEmiSchedule from "../../loans/components/GeneratedEmiSchedule";
// import GoldCustodyAcknowledgementReceipt from "../../../components/ui/GoldCustodyAcknowledgementReceipt";
// import NomineeAuthorizationLetter from "../../loans/components/NomineeAuthorizationLetter";
// import ConsentForm from "../components/ConsentForm.css";
// import LoanAgreement from "../../loans/components/LoanAgreement.css";

// const MemberDetailPrint = () => {
//   const navigate = useNavigate();
//   const ref = useRef();
//   const memberDetails = JSON.parse(localStorage.getItem("memberDetails"));
//   const [loading, setLoading] = useState(false);

//   const handleDownload = async () => {
//     setLoading(true);

//     const input = ref.current;
//     const pdf = new jsPDF("p", "mm", "a4");
//     const originalPdfWidth = pdf.internal.pageSize.getWidth();
//     const originalPdfHeight = pdf.internal.pageSize.getHeight();
//     const pdfWidth = originalPdfWidth * 0.9;
//     const pdfHeight = originalPdfHeight * 0.9;
//     const xOffset = (originalPdfWidth - pdfWidth) / 2;
//     const yOffset = (originalPdfHeight - pdfHeight) / 2;
//     const sections = input.querySelectorAll(".section");

//     let heightLeft = pdfHeight;

//     for (let i = 0; i < sections.length; i++) {
//       const section = sections[i];

//       const canvas = await html2canvas(section, { useCORS: true, scale: 2 });
//       const imgData = canvas.toDataURL("image/jpeg", 0.7);
//       const imgProps = pdf.getImageProperties(imgData);
//       const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

//       if (
//         heightLeft < imgHeight ||
//         section.classList.contains("sanction-letter-section")
//       ) {
//         pdf.addPage();
//         heightLeft = pdfHeight;
//       }

//       pdf.addImage(
//         imgData,
//         "JPEG",
//         xOffset,
//         yOffset + (pdfHeight - heightLeft),
//         pdfWidth,
//         imgHeight
//       );
//       heightLeft -= imgHeight;

//       // Add border to the current page after content is added
//       pdf.rect(5, 5, originalPdfWidth - 10, originalPdfHeight - 10); // Rect (x, y, width, height)
//     }

//     pdf.setProperties({
//       title: "Document",
//       subject: "Generated Document",
//       author: "Your Name",
//       keywords: "generated, javascript, web 2.0, ajax",
//       creator: "Your App",
//     });

//     pdf.save(`${memberDetails.memberDetails.memberName}-Loan Application`);
//     setLoading(false);
//   };

//   return (
//     <div>
//       <div className="button-container">
//         {/* <button className="btn btn-danger" onClick={() => navigate(-1)}>
//           Back
//         </button> */}
//         <button
//           className="btn btn-success"
//           onClick={handleDownload}
//           disabled={loading}
//         >
//           {loading ? "Downloading..." : "Download PDF"}
//         </button>
//       </div>

//       <div ref={ref} className="print-container">
//         <div>
//           <div className="header section">
//             {memberDetails.memberDetails.loanType === "Business Loan" && (
//               <p>Application form - Micro Enterprise Loan</p>
//             )}
//             {memberDetails.memberDetails.loanType === "GP Loan" && (
//               <p>Application form - Suvarna Vrddhi Loan</p>
//             )}
//           </div>
//           <div className="section">
//             <div className="sub-header">
//               <p>Applicant's Personal Details</p>
//             </div>

//             <div className="d-flex">
//               <DetailTable
//                 details={memberDetails.memberDetails}
//                 fields={memberFields}
//               />
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "start",
//                 }}
//               >
//                 <PhotoTable
//                   details={memberDetails.memberDocuments}
//                   fields={[
//                     {
//                       key: "memberPhoto",
//                       label: "Applicant ",
//                     },
//                   ]}
//                 />
//                 <NomineePhotoTable
//                   details={memberDetails.nomineeDocuments}
//                   fields={[
//                     {
//                       key: "nomineePhoto",
//                       label: "Co-Applicant",
//                     },
//                   ]}
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="section">
//             <div className="sub-header">
//               <p>Employment Details</p>
//             </div>
//             <DetailTable
//               details={memberDetails.businessDetails}
//               fields={businessFields}
//             />
//           </div>

//           <div className="section">
//             <div className="sub-header">
//               <p>Applicant Residence Address</p>
//             </div>
//             <DetailTable
//               details={memberDetails.memberDetails}
//               fields={residenceFields}
//             />
//           </div>

//           <div className="section">
//             <div className="sub-header">
//               <p>Applicant Permanent Address</p>
//             </div>
//             <DetailTable
//               details={memberDetails.memberDetails}
//               fields={permanentResidenceFields}
//             />
//           </div>

//           <div className="section">
//             <div className="sub-header">
//               <p>Co-Applicant Personal Details</p>
//             </div>
//             <DetailTable
//               details={memberDetails.coApplicantDetails}
//               fields={CoApplicantPersonalFields}
//             />
//           </div>

//           <div className="section">
//             <div className="sub-header">
//               <p>Co-Applicant Employment Details</p>
//             </div>
//             <DetailTable
//               details={memberDetails.familyBusinessDetails}
//               fields={coApplicantBusinessFields}
//             />
//           </div>

//           <div className="section">
//             <div className="sub-header">
//               <p>Co-Applicant Residence Address</p>
//             </div>
//             <DetailTable
//               details={memberDetails.coApplicantDetails}
//               fields={coApplicantResidenceFields}
//             />
//           </div>
//           <div className="section">
//             <div className="sub-header">
//               <p>Co-Applicant Permanent Address</p>
//             </div>
//             <DetailTable
//               details={memberDetails.coApplicantDetails}
//               fields={coApplicantPermanentResidenceFields}
//             />
//           </div>
//           <div className="section">
//             <div className="sub-header">
//               <p>Existing Loan Details</p>
//             </div>
//             <DetailTable
//               details={memberDetails.loanDetails}
//               fields={loanDetailsFields}
//             />
//           </div>

//           <div className="section">
//             <div className="sub-header">
//               <p>Proposed Loan Details</p>
//             </div>
//             <DetailTable
//               details={{
//                 ...memberDetails.proposedLoanDetails,
//                 // Override emiDate with the appropriate value
//                 emiDate:
//                   memberDetails?.memberDetails?.emiDateByBranchManager ??
//                   memberDetails.proposedLoanDetails.emiDate,
//               }}
//               fields={proposedLoanDetailsFields}
//             />
//           </div>

//           <div className="section">
//             <div className="sub-header">
//               <p>Bank Details</p>
//             </div>
//             <DetailTable
//               details={memberDetails.bankDetails}
//               fields={bankDetailsFields}
//             />
//           </div>
//           <div className="section">
//             <div className="sub-header">
//               <p>Signature of Applicant and Co-Applicant</p>
//             </div>
//             <table className="member-details-table">
//               <tbody>
//                 <tr>
//                   <td>
//                     <div style={{ display: "flex" }}>
//                       <div className="label-container">
//                         <p>Applicant's Signature</p>
//                       </div>
//                       <div className="label-container">
//                         <p></p>
//                       </div>
//                       <div className="label-container">
//                         <p>Co-Applicant's Signature</p>
//                       </div>
//                       <div className="value-container">
//                         <p></p>
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//           <div>
//             <div className="section sanction-letter-section d-flex justify-content-end ">
//               <img
//                 src={require("../../../assets/vetrivikaslogo.jpeg")}
//                 alt="logo"
//                 className="printlogo"
//               />
//             </div>
//             <MemberSanctionLetter memberDetails={memberDetails} />
//           </div>
//           {memberDetails.memberDetails.loanType === "Business Loan" && (
//             <div>
//               <DisbursementRequestForm memberDetails={memberDetails} />
//             </div>
//           )}
//           {memberDetails.memberDetails.loanType === "GP Loan" && (
//             <div>
//               <GoldCustodyAcknowledgementReceipt
//                 memberDetails={memberDetails}
//               />
//             </div>
//           )}
//           {memberDetails.memberDetails.loanType === "GP Loan" && (
//             <div>
//               <NomineeAuthorizationLetter memberDetails={memberDetails} />
//             </div>
//           )}
//           <div>
//             <div className="section sanction-letter-section d-flex justify-content-end ">
//               <img
//                 src={require("../../../assets/vetrivikaslogo.jpeg")}
//                 alt="logo"
//                 className="printlogo"
//               />
//             </div>
//             <GeneratedEmiSchedule memberDetails={memberDetails} />
//             <div
//               className="section d-flex justify-content-between"
//               style={{ fontSize: "20px" }}
//             >
//               <div className="mt-5">
//                 <p> ________________</p>
//                 <p>Signature Of Applicant</p>
//                 <p>விண்ணப்பதாரரின் கையொப்பம்</p>
//               </div>
//               <div className="mt-5">
//                 <p> ________________</p>
//                 <p>Signature Of Branch Manager</p>
//                 <p> கிளை மேலாளர் கையொப்பம் </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MemberDetailPrint;




import React, { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import "./MemberPrint.css";

import {
  DetailTable,
  PhotoTable,
  NomineePhotoTable,
  memberFields,
  businessFields,
  residenceFields,
  permanentResidenceFields,
  CoApplicantPersonalFields,
  coApplicantBusinessFields,
  coApplicantResidenceFields,
  coApplicantPermanentResidenceFields,
  loanDetailsFields,
  proposedLoanDetailsFields,
  proposedLoanDetailsFieldsForDailyLoan,
  bankDetailsFields,
} from "../../../components/ui/TablePrintFormat";

import MemberSanctionLetter from "../../loans/components/MemberSanctionLetter";
import DisbursementRequestForm from "../../users-management/components/DisbursementRequestForm";
import GeneratedEmiSchedule from "../../loans/components/GeneratedEmiSchedule";
import GoldCustodyAcknowledgementReceipt from "../../../components/ui/GoldCustodyAcknowledgementReceipt";
import NomineeAuthorizationLetter from "../../loans/components/NomineeAuthorizationLetter";
import ConsentForm from "../components/ConsentForm";
import LoanAgreement from "../../loans/components/LoanAgreement";

const MemberDetailPrint = () => {
  const navigate = useNavigate();
  const ref = useRef();
  const memberDetails = JSON.parse(localStorage.getItem("memberDetails"));
  const [loading, setLoading] = useState(false);

  const getDisbDateComponents = () => {
    const disbDateString = memberDetails?.memberDetails?.branchManagerStatusUpdatedAt;

    if (disbDateString) {
      // Create date object from the disbDate
      const disbDate = new Date(disbDateString);

      return {
        date: disbDate.getDate().toString(),
        month: disbDate.toLocaleString('default', { month: 'long' }),
        year: disbDate.getFullYear().toString()
      };
    } else {
      // Fallback to current date if disbDate is not available
      const currentDate = new Date();
      return {
        date: currentDate.getDate().toString(),
        month: currentDate.toLocaleString('default', { month: 'long' }),
        year: currentDate.getFullYear().toString()
      };
    }
  };

  // Usage in your LoanAgreement component
  const { date, month, year } = getDisbDateComponents();
  // Number to Words Function
  const numberToWords = (num) => {
    if (num === 0) return "Zero";

    const ones = [
      "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
      "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
      "Seventeen", "Eighteen", "Nineteen"
    ];

    const tens = [
      "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
    ];

    const scales = ["", "Thousand", "Lakh", "Crore"];

    function convertHundreds(n) {
      let result = "";

      if (n >= 100) {
        result += ones[Math.floor(n / 100)] + " Hundred ";
        n %= 100;
      }

      if (n >= 20) {
        result += tens[Math.floor(n / 10)] + " ";
        n %= 10;
      }

      if (n > 0) {
        result += ones[n] + " ";
      }

      return result;
    }

    function convertIndianNumbering(num) {
      if (num === 0) return "Zero";

      let crores = Math.floor(num / 10000000);
      num %= 10000000;

      let lakhs = Math.floor(num / 100000);
      num %= 100000;

      let thousands = Math.floor(num / 1000);
      num %= 1000;

      let hundreds = num;

      let result = "";

      if (crores > 0) {
        result += convertHundreds(crores) + "Crore ";
      }

      if (lakhs > 0) {
        result += convertHundreds(lakhs) + "Lakh ";
      }

      if (thousands > 0) {
        result += convertHundreds(thousands) + "Thousand ";
      }

      if (hundreds > 0) {
        result += convertHundreds(hundreds);
      }

      return result.trim();
    }

    // Handle decimal numbers
    const numStr = num.toString();
    const parts = numStr.split('.');
    const integerPart = parseInt(parts[0]);
    const decimalPart = parts[1] ? parseInt(parts[1]) : 0;

    let words = convertIndianNumbering(integerPart);

    if (decimalPart > 0) {
      words += " and " + convertIndianNumbering(decimalPart) + " Paise";
    }

    return words + " Rupees Only";
  };

  const handleDownload = async () => {
    setLoading(true);

    const input = ref.current;
    const pdf = new jsPDF("p", "mm", "a4");
    const originalPdfWidth = pdf.internal.pageSize.getWidth();
    const originalPdfHeight = pdf.internal.pageSize.getHeight();
    const pdfWidth = originalPdfWidth * 0.9;
    const pdfHeight = originalPdfHeight * 0.9;
    const xOffset = (originalPdfWidth - pdfWidth) / 2;
    const yOffset = (originalPdfHeight - pdfHeight) / 2;
    const sections = input.querySelectorAll(".section");

    let heightLeft = pdfHeight;

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];

      const canvas = await html2canvas(section, { useCORS: true, scale: 2 });
      const imgData = canvas.toDataURL("image/jpeg", 0.7);
      const imgProps = pdf.getImageProperties(imgData);
      const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

      if (
        heightLeft < imgHeight ||
        section.classList.contains("sanction-letter-section") ||
        section.classList.contains("consent-form-page") ||
        section.classList.contains("loan-agreement-page")
      ) {
        pdf.addPage();
        heightLeft = pdfHeight;
      }

      pdf.addImage(
        imgData,
        "JPEG",
        xOffset,
        yOffset + (pdfHeight - heightLeft),
        pdfWidth,
        imgHeight
      );
      heightLeft -= imgHeight;

      // Add border to the current page after content is added
      pdf.rect(5, 5, originalPdfWidth - 10, originalPdfHeight - 10); // Rect (x, y, width, height)
    }

    pdf.setProperties({
      title: "Document",
      subject: "Generated Document",
      author: "Your Name",
      keywords: "generated, javascript, web 2.0, ajax",
      creator: "Your App",
    });

    pdf.save(`${memberDetails.memberDetails.memberName}-Loan Application`);
    setLoading(false);
  };

  // Get loan amount in words
  const getLoanAmountInWords = () => {
    const loanAmount = memberDetails?.memberDetails?.eligibleLoanAmountByBm ||
      memberDetails?.proposedLoanDetails?.loanAmount || 0;
    return numberToWords(parseFloat(loanAmount));
  };

  return (
    <div>
      <div className="button-container">
        {/* <button className="btn btn-danger" onClick={() => navigate(-1)}>
          Back
        </button> */}
        <button
          className="btn btn-success"
          onClick={handleDownload}
          disabled={loading}
        >
          {loading ? "Downloading..." : "Download PDF"}
        </button>
      </div>

      <div ref={ref} className="print-container">
        <div>
          <div className="header section">
            {memberDetails.memberDetails.loanType === "Business Loan" && (
              <p>Application form - Micro Enterprise Loan</p>
            )}
            {memberDetails.memberDetails.loanType === "GP Loan" && (
              parseFloat(memberDetails.memberDetails.cashtloanotal || 0) > 0 ? (
                <p>Application form - Suvarna Nithi Loan</p>
              ) : (
                <p>Application form - Suvarna Vrddhi Loan</p>
              )
            )}
          </div>
          <div className="section">
            <div className="sub-header">
              <p>Applicant's Personal Details</p>
            </div>

            <div className="d-flex">
              <DetailTable
                details={memberDetails.memberDetails}
                fields={memberFields}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "start",
                }}
              >
                <PhotoTable
                  details={memberDetails.memberDocuments}
                  fields={[
                    {
                      key: "memberPhoto",
                      label: "Applicant ",
                    },
                  ]}
                />
                <NomineePhotoTable
                  details={memberDetails.nomineeDocuments}
                  fields={[
                    {
                      key: "nomineePhoto",
                      label: "Co-Applicant",
                    },
                  ]}
                />
              </div>
            </div>
          </div>

          <div className="section">
            <div className="sub-header">
              <p>Employment Details</p>
            </div>
            <DetailTable
              details={memberDetails.businessDetails}
              fields={businessFields}
            />
          </div>

          <div className="section">
            <div className="sub-header">
              <p>Applicant Residence Address</p>
            </div>
            <DetailTable
              details={memberDetails.memberDetails}
              fields={residenceFields}
            />
          </div>

          <div className="section">
            <div className="sub-header">
              <p>Applicant Permanent Address</p>
            </div>
            <DetailTable
              details={memberDetails.memberDetails}
              fields={permanentResidenceFields}
            />
          </div>

          <div className="section">
            <div className="sub-header">
              <p>Co-Applicant Personal Details</p>
            </div>
            <DetailTable
              details={memberDetails.coApplicantDetails}
              fields={CoApplicantPersonalFields}
            />
          </div>

          <div className="section">
            <div className="sub-header">
              <p>Co-Applicant Employment Details</p>
            </div>
            <DetailTable
              details={memberDetails.familyBusinessDetails}
              fields={coApplicantBusinessFields}
            />
          </div>

          <div className="section">
            <div className="sub-header">
              <p>Co-Applicant Residence Address</p>
            </div>
            <DetailTable
              details={memberDetails.coApplicantDetails}
              fields={coApplicantResidenceFields}
            />
          </div>
          <div className="section">
            <div className="sub-header">
              <p>Co-Applicant Permanent Address</p>
            </div>
            <DetailTable
              details={memberDetails.coApplicantDetails}
              fields={coApplicantPermanentResidenceFields}
            />
          </div>
          <div className="section">
            <div className="sub-header">
              <p>Existing Loan Details</p>
            </div>
            <DetailTable
              details={memberDetails.loanDetails}
              fields={loanDetailsFields}
            />
          </div>

          <div className="section">
            <div className="sub-header">
              <p>Proposed Loan Details</p>
            </div>
            <DetailTable
              details={{
                ...memberDetails.proposedLoanDetails,
                // Override emiDate with the appropriate value
                emiDate:
                  memberDetails?.memberDetails?.emiDateByBranchManager ??
                  memberDetails.proposedLoanDetails.emiDate,
              }}
              fields={
                memberDetails?.memberDetails?.loanType === "Daily Loan"
                  ? proposedLoanDetailsFieldsForDailyLoan
                  : proposedLoanDetailsFields
              }
            />
          </div>

          <div className="section">
            <div className="sub-header">
              <p>Bank Details</p>
            </div>
            <DetailTable
              details={memberDetails.bankDetails}
              fields={bankDetailsFields}
            />
          </div>
          <div className="section">
            <div className="sub-header">
              <p>Signature of Applicant and Co-Applicant</p>
            </div>
            <table className="member-details-table">
              <tbody>
                <tr>
                  <td>
                    <div style={{ display: "flex" }}>
                      <div className="label-container">
                        <p>Applicant's Signature</p>
                      </div>
                      <div className="label-container">
                        <p></p>
                      </div>
                      <div className="label-container">
                        <p>Co-Applicant's Signature</p>
                      </div>
                      <div className="value-container">
                        <p></p>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Consent Form Section - Separate A4 Sheet - Only for GP Loan */}
          {memberDetails?.memberDetails?.loanType === "GP Loan" && (
            <div className="section consent-form-page" style={{ pageBreakBefore: 'always', pageBreakAfter: 'always', minHeight: '100vh' }}>
              <ConsentForm
                date={memberDetails?.memberDetails?.branchManagerStatusUpdatedAt || new Date().toLocaleDateString("en-US")}
                place={memberDetails?.branchName || "Madurai"}
                customerName={memberDetails?.memberDetails?.memberName || "Customer Name"}
                secondName={memberDetails?.coApplicantDetails?.coApplicantName || "Father Name"}
                customerAddress={`${memberDetails?.memberDetails?.permanentDoorNo || ""}, ${memberDetails?.memberDetails?.permanentStreetNo || ""}, ${memberDetails?.memberDetails?.permanentPanchayat || ""} - ${memberDetails?.memberDetails?.permanentTaluk || ""}, ${memberDetails?.memberDetails?.permanentDistrict || ""}`.replace(/^[,\s-]+|[,\s-]+$/g, '') || "[Address]"}
                loanAmount={memberDetails?.memberDetails?.goldloantotal || memberDetails?.memberDetails?.eligibleLoanAmountByBm || memberDetails?.proposedLoanDetails?.loanAmount || "Loan Amount"}
                loanAmountInWords={getLoanAmountInWords()}
                mobileNumber={memberDetails?.memberDetails?.phoneNumber || "N/A"}
                aadhaarNo={memberDetails?.memberDetails?.aadharNo || "N/A"}
              />
            </div>
          )}

          {/* Loan Agreement Section - Separate A4 Sheet - Only for GP Loan */}
          {memberDetails?.memberDetails?.loanType === "GP Loan" && (
            <div className="section loan-agreement-page" style={{ pageBreakBefore: 'always', pageBreakAfter: 'always', minHeight: '100vh' }}>
              <LoanAgreement
                date={date}
                month={month}
                year={year}
                borrowerName={memberDetails?.memberDetails?.memberName || "[BORROWER NAME]"}
                borrowerAddress={`${memberDetails?.memberDetails?.permanentDoorNo || ""},, ${memberDetails?.memberDetails?.permanentStreetNo || ""}, ${memberDetails?.memberDetails?.permanentPanchayat || ""} - ${memberDetails?.memberDetails?.permanentTaluk || ""}, ${memberDetails?.memberDetails?.permanentDistrict || ""}`.replace(/^[,\s-]+|[,\s-]+$/g, '') || "[Address]"}
                loanAmount={memberDetails?.memberDetails?.eligibleLoanAmountByBm || memberDetails?.proposedLoanDetails?.loanAmount || "__________"}
                loanAmountInWords={getLoanAmountInWords()}
                jewellerName="Sethuraman Jewellers"
                jewellerAddress="Kattukudipatti"
                repaymentFrequency="monthly"
                tenureMonths={memberDetails?.proposedLoanDetails?.tenureInMonths || "[tenure]"}
                disbDate={memberDetails?.memberDetails?.branchManagerStatusUpdatedAt || "[Disb Date]"}
                interestRate={memberDetails?.proposedLoanDetails?.interestRate || "0"}
                interestType="simple"
                noticePeriod="15"
                jurisdictionCity="Madurai"
              />
            </div>
          )}

          <div>
            <div className="section sanction-letter-section d-flex justify-content-end ">
              <img
                src={require("../../../assets/vetrivikaslogo.jpeg")}
                alt="logo"
                className="printlogo"
              />
            </div>
            <MemberSanctionLetter memberDetails={memberDetails} />
          </div>
          {memberDetails.memberDetails.loanType === "Business Loan" && (
            <div style={{ pageBreakBefore: 'always', pageBreakAfter: 'always', minHeight: '100vh' }}>
              <DisbursementRequestForm memberDetails={memberDetails} />
            </div>
          )}
          {memberDetails.memberDetails.loanType === "GP Loan" && (
            <div style={{ pageBreakBefore: 'always', pageBreakAfter: 'always', minHeight: '100vh' }}>
              <GoldCustodyAcknowledgementReceipt
                memberDetails={memberDetails}
              />
            </div>
          )}
          {memberDetails.memberDetails.loanType === "GP Loan" && (
            <div style={{ pageBreakBefore: 'always', pageBreakAfter: 'always', minHeight: '100vh' }}>
              <NomineeAuthorizationLetter memberDetails={memberDetails} />
            </div>
          )}
          <div>
            <div className="section sanction-letter-section d-flex justify-content-end ">
              <img
                src={require("../../../assets/vetrivikaslogo.jpeg")}
                alt="logo"
                className="printlogo"
              />
            </div>
            <GeneratedEmiSchedule memberDetails={memberDetails} />
            <div
              className="section d-flex justify-content-between"
              style={{ fontSize: "20px" }}
            >
              <div className="mt-5">
                <p> ________________</p>
                <p>Signature Of Applicant</p>
                <p>விண்ணப்பதாரரின் கையொப்பம்</p>
              </div>
              <div className="mt-5">
                <p> ________________</p>
                <p>Signature Of Branch Manager</p>
                <p> கிளை மேலாளர் கையொப்பம் </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberDetailPrint;